import { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Al montar, intentamos recuperar la sesión desde la cookie httpOnly.
  useEffect(() => {
    api
      .get('/auth/me')
      .then(({ data }) => setUser(data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    setUser(data.user);
    return data.user;
  };

  const registerMayorista = async (payload) => {
    const { data } = await api.post('/auth/register-mayorista', payload);
    setUser(data.user);
    return data.user;
  };

  const resetPassword = async (token, password) => {
    const { data } = await api.post('/auth/reset-password', { token, password });
    setUser(data.user); // el backend deja la sesión iniciada (cookie)
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch {
      /* no-op */
    }
    setUser(null);
  };

  const updateUser = (partial) => setUser((u) => ({ ...u, ...partial }));

  return (
    <AuthContext.Provider
      value={{
        user, loading, login, register, registerMayorista, resetPassword, logout, updateUser,
        isAdmin: user?.role === 'admin',
        isStaff: ['admin', 'editor', 'depot'].includes(user?.role),
        isMayorista: user?.role === 'mayorista',
        wholesaleApproved:
          ['admin', 'editor', 'depot'].includes(user?.role) ||
          user?.role === 'mayorista',
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
